import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const inviteMembers = createAsyncThunk(
    "inviteMembers",
    async ({ groupId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/group/groups/${groupId}/members/`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error inviting members");
        }
    }
);

export const searchMembers = createAsyncThunk(
    "searchMembers",
    async ({ groupId, query }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/group/groups/${groupId}/users/search/?q=${query}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error searching members");
        }
    }
);

export const GroupInviteMemberSlice = createSlice({
    name: "GroupInviteMemberSlice",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(inviteMembers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(inviteMembers.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        });
        builder.addCase(inviteMembers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default GroupInviteMemberSlice.reducer;
